import { usePageTitle } from "../../../../../shared/hooks/usePageTitle";
import { Working } from "../../../../../shared/ui/Working";
import { PageHead, PageShell } from "../../components/PageShell";
import { useTranslation } from "../../i18n/useTranslation";

/**
 * The appointment page's body while it loads. In its own module so the router
 * can show it while the page's chunk is still arriving (routes.tsx, /a), and
 * the page shows the same nodes while its data loads: no layout shift between
 * the two (rc.9 entry headroom). The page wraps it in its own shell, so that
 * shell (header, legal line) stays mounted from loading to loaded.
 */
export function AppointmentLoadingBody() {
  const { t } = useTranslation();
  return (
    <>
      <PageHead title={t("appt.heading")} />
      <Working>{t("appt.loading")}</Working>
    </>
  );
}

/** The router's fallback for /a while the chunk loads: the page's shell, body and title. */
export function AppointmentRouteLoading() {
  const { t } = useTranslation();
  usePageTitle(t("appt.heading"));
  return (
    // `route-loading` tells the fallback from the page itself (tests wait for
    // the page); a data attribute only, so the layout is the same.
    <PageShell layout="management" testId="appointment-action" state="route-loading">
      <AppointmentLoadingBody />
    </PageShell>
  );
}
